// Import React Systems
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Import Atoms
import ButtonComp from "../../../atoms/button/Button"
import Text from "../../../atoms/text/Text"

// Import Molecules
import Notification from "../../../molecules/notification/Notification";
import Search from "../../../molecules/search/Search";

// Imports MUI Components
import {  
  Box,
  Stack,
  Typography,
  CircularProgress,
  Button,
  Drawer,
  Tooltip,
} from "@mui/material"
import { useMediaQuery, useTheme } from "@mui/material";

// Import Assets

// Import Atoms
import Icon from "../../../atoms/icon/Icon"

// Import Functions
import { fetchUserDetails } from "../../../../functions/fetchUserDetails"

import "./styles.css"
import Sidebar from "../../sidebar/Sidebar";

const HeaderLoggedIn = ({ 
  count, 
  page,
  setShowNotifications,
  unreadCount,
  showNotifications,
  notifications,
  setNotifications,
  setShowNotificationsModal,
  setIsModalOpen,
  handleSearch,
  searchTerm,
  setSearchTerm,
  onAdd,
  check
}) => {

  const navigate = useNavigate();
  const [editingKey, setEditingKey] = useState(null);
  const [itemName, setItemName] = useState("");
  const [pricePerUnit, setPricePerUnit] = useState("");
  const [quantity, setQuantity] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);

  const [userDetails, setUserDetails] = useState(null);
  const [isScheduleAppointmentLoading, setIsScheduleAppointmentLoading] = useState(false);
  const [isManageAppointmentLoading, setIsManageAppointmentLoading] = useState(false);

  const buttonRefs = [useRef(null), useRef(null), useRef(null)];

  const stepTexts = [
    "This is button 1",
    "This is button 2",
    "This is button 3",
  ];

  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const totalSteps = stepTexts.length;

  const [step, setStep] = useState(0);
  const [spotlightStyle, setSpotlightStyle] = useState({});

  const updateSpotlight = () => {
    const target = buttonRefs[step]?.current;
    if (!target) return;

    const rect = target.getBoundingClientRect();

    setSpotlightStyle({
      top: rect.top - 10,
      left: rect.left - 10,
      width: rect.width + 20,
      height: rect.height + 20,
    });
  };

  // useEffect(() => {
  //   updateSpotlight();

  //   window.addEventListener("resize", updateSpotlight);
  //   window.addEventListener("scroll", updateSpotlight, true);

  //   const resizeObserver = new ResizeObserver(updateSpotlight);
  //   resizeObserver.observe(document.body);

  //   return () => {
  //     window.removeEventListener("resize", updateSpotlight);
  //     window.removeEventListener("scroll", updateSpotlight, true);
  //     resizeObserver.disconnect();
  //   };
  // }, [step]);

  const [open, setOpen] = React.useState(false);

  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleHamburgerToggle = (e) => {
    setMenuOpen(e.target.checked);
  };

  // Handle Schedule Appointment button click
  const handleScheduleAppointmentClick = async () => {
    setIsScheduleAppointmentLoading(true);
    
    // Add a small delay to show loading state
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Reset loading state after navigation
    setIsScheduleAppointmentLoading(false);
    navigate("/patient-appointment-booking", { replace: true });
  };

  // Handle Manage Appointment button click
  const handleManageAppointmentClick = async () => {
    setIsManageAppointmentLoading(true);
    
    // Add a small delay to show loading state
    await new Promise(resolve => setTimeout(resolve, 500));
    
    navigate("/manage-appointment", { replace: true });
    
    // Reset loading state after navigation
    setIsManageAppointmentLoading(false);
  };

  /** Full navigation fixes occasional SPA desync (URL /dashboard vs Manage Appointment UI). */
  const goToDashboardWithReload = () => {
    window.location.assign(`${window.location.origin}/dashboard`);
  };

  const DrawerList = (
    <Sidebar
      fName={userDetails?.firstName}
      lName={userDetails?.lastName}
      email={userDetails?.email}
    />
  );

  // UseEffects
  useEffect(() => {
    const details = fetchUserDetails(setUserDetails);
    return () => {
      details && details();
    };
  }, []);

  // Don't render anything until userDetails is loaded to prevent flashing
  if (!userDetails) {
    return (
      <div>
        <Box
          sx={{
            backgroundColor: "#FEFEFE",
            borderBottom: "1px solid rgba(89, 84, 75, .2)",
            padding: "20px 30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
          <CircularProgress size={24} sx={{ color: "#C5A572" }} />
        </Box>
      </div>
    );
  }

  return (
    <div>


      {/* Schedule Appointment Button*/}
      {userDetails?.role === "Patient" ? (

        // Patient Header
        <>

          {count === 1 ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : page === "Appointment Page" ? "#2E2D2D" :
                   "#2E2D2D",
                  sm : page === "Appointment Page" ? "#2E2D2D" :
                   "#2E2D2D",
                  md : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                  lg : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                  xl : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : page === "Appointment Page" ? null :
                   "23px 15px",
                  sm : page === "Appointment Page" ? null :
                   "23px 15px",
                  md : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                  lg : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                  xl : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                }
              }}>

              {page !== "Appointment Page" ? (
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "start",
                      lg: "start",
                      xl: "start",
                    },
                    position: "relative",
                    padding: {
                      xs : null,
                      sm : null,
                      md : "15px 0",
                      lg : null,
                      xl : null,
                    }
                  }}
                >
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>
</Stack>
              ) : (
                <>
                              <Box
                component="button"
                type="button"
                onClick={goToDashboardWithReload}
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "row",
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  cursor: "pointer",
                  font: "inherit",
                  color: "inherit",
                  textAlign: "left",
                }}
              >
            <Stack
              direction="row"
              spacing={0}
              sx={{
                alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  textDecoration: "none",
                  padding: "5px 20px"
              }}>

                <Icon
                  src={require("../../../../../assets/back_light.png")}
                  size="large-no-margin"/>
              
            
              <Typography 
                variant="h2"
                sx={{
                  color: "#FDF9F3",
                  fontSize: "14px",
                  fontWeight: "300",
                  padding: "15px 10px",
                  textDecoration: "none",
                }}
              >Back to Dashboard</Typography>

            </Stack>
          </Box>
                </>
              )}

            </Box>
          ) : count === 2 ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : check === 0 ? "23px 15px" : "23px 15px",
                  sm : check === 0 ? "23px 15px" : "23px 15px",
                  md : check === 0 ? "30px" : "18px 40px 18px 30px",
                  lg : check === 0 ? "30px" : "18px 40px 18px 30px",
                  xl : check === 0 ? "30px" : "18px 40px 18px 30px",
                }
                  
              }}>

              <Stack
                direction="row"
                spacing={{
                  xs : 2,
                  sm : 2,
                  md : null,
                  lg : null,
                  xl : null,
                }}
                sx={{
                  justifyContent: {
                    xs : "center",
                    sm : "center",
                    md : "space-between",
                    lg : "space-between",
                    xl : "space-between",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  },
                  position: "relative",
                  alignItems: "center"
                }}>
                <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "start",
                    lg: "start",
                    xl: "start",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  }
                }}>
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>

                <Box
                  display={{
                    xs: "flex",
                    sm: "flex",
                    md: "none",
                    lg: "none",
                    xl: "none",
                  }}
                  sx={{
                    position: "absolute",
                    right: "10px",
                    borderRadius: "50px"
                  }}
                >
  <div className="input-container">
    <img
      src={require("../../../../../assets/icons/search_light.png")}
      alt="icon"
      className="small"
      style={{
        position: "absolute",
        left: "8px",
        top: "32%",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        zIndex: 2,
        pointerEvents: "none",
      }}
    />

    <input
      type="text"
      name="text"
      className="input"
      placeholder="Search..."
      value={searchTerm}
      onChange={handleSearch}
    />

    {searchTerm === "asf" && (
      <button
        type="button"
        aria-label="Clear search"
        onClick={() => setSearchTerm("")}
        style={{
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          padding: 6,
          cursor: 'pointer',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icons" width="24" height="24">
          <g strokeWidth="0" id="SVGRepo_bgCarrier"></g>
          <g strokeLinejoin="round" strokeLinecap="round" id="SVGRepo_tracerCarrier"></g>
          <g id="SVGRepo_iconCarrier">
            <rect fill="white" height="24" width="24"></rect>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.9a1 1 0 0 0 1.41-1.41L13.41 12l4.9-4.89a1 1 0 0 0 0-1.4z" fillRule="evenodd" clipRule="evenodd" />
          </g>
        </svg>
      </button>
      )}
    

  </div>
                  {/* </Box> */}
                </Box>
</Stack>
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                {check !== 0 && (
                  <Search
                    handleSearch={handleSearch}
                    value={searchTerm}/>
                )}
                </Box>
                </Stack>

              </Box>
          ) : (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : "10px 30px",
                  sm : "10px 30px",
                  md : "20px 30px",
                  lg : "20px 30px",
                  xl : "20px 30px",
                }
              }}>

              <Stack
                direction="row"
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center"
                }}>
                
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              onClick={toggleDrawer(true)}
              // ref={buttonRefs[0]}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text="Dashboard"
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text="Dashboard"
                  variant="headerh1DarkMode"/>
                </Box>
                <Box>

                <Stack
                  direction="row"
                  spacing={3}
                  sx={{
                    alignItems: "center",
                  }}
                  // ref={buttonRefs[2]}
                >

                  <Notification
                    setShowNotifications={setShowNotifications}
                    unreadCount={unreadCount}
                    showNotifications={showNotifications}
                    notifications={notifications}
                    setNotifications={setNotifications}
                    setShowNotificationsModal={setShowNotificationsModal}
                    userDetails={userDetails}/>

                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <Button
                    variant="contained"
                    onClick={handleScheduleAppointmentClick}
                    disabled={isScheduleAppointmentLoading}
                    sx={{
                      backgroundColor: "#C5A572",
                      color: "#FDF9F3",
                      border: "1px solid #C5A572",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      cursor: isScheduleAppointmentLoading ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      textTransform: "none",
                      fontWeight: "bold",
                      fontSize: "14px",
                      "&:hover": {
                        backgroundColor: "#B8955A",
                        borderColor: "#B8955A",
                      },
                      "&:disabled": {
                        backgroundColor: "#E0D6C3",
                        borderColor: "#E0D6C3",
                        color: "#999",
                      },
                    }}
                  >
                    {isScheduleAppointmentLoading ? (
                      <>
                        <CircularProgress size={16} sx={{ color: "#FDF9F3" }} />
                        <span>Schedule Appointmentss</span>
                      </>
                    ) : (
                      "Schedule Appointment"
                    )}
                  </Button>
                    
                  </Box>

                </Stack>
                </Box>

              </Stack>

            </Box>
          )}

        </>
      ) : (

        // Personnel Header
        <>

          {count === 1 ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                zIndex: "9999",
                backgroundColor: {
                  xs : page === "Appointment Page" ? "#2E2D2D" :
                   "#2E2D2D",
                  sm : page === "Appointment Page" ? "#2E2D2D" :
                   "#2E2D2D",
                  md : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                  lg : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                  xl : page === "Appointment Page" ? "#2E2D2D" :
                   "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : page === "Appointment Page" ? null :
                   "23px 15px",
                  sm : page === "Appointment Page" ? null :
                   "23px 15px",
                  md : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                  lg : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                  xl : page === "Appointment Page" ? null :
                   "18px 40px 18px 30px",
                }
              }}>

              {page !== "Appointment Page" ? (
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "start",
                      lg: "start",
                      xl: "start",
                    },
                    position: "relative",
                    padding: {
                      xs : null,
                      sm : null,
                      md : "15px 0",
                      lg : null,
                      xl : null,
                    }
                  }}
                >
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>
</Stack>
              ) : (
                <>
                              <Box
                component="button"
                type="button"
                onClick={goToDashboardWithReload}
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "row",
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  cursor: "pointer",
                  font: "inherit",
                  color: "inherit",
                  textAlign: "left",
                }}
              >
            <Stack
              direction="row"
              spacing={0}
              sx={{
                alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  textDecoration: "none",
                  padding: "5px 20px"
              }}>

                <Icon
                  src={require("../../../../../assets/back_light.png")}
                  size="large-no-margin"/>
              
            
              <Typography 
                variant="h2"
                sx={{
                  color: "#FDF9F3",
                  fontSize: "14px",
                  fontWeight: "300",
                  padding: "15px 10px",
                  textDecoration: "none",
                }}
              >Back to Dashboard</Typography>

            </Stack>
          </Box>
                </>
              )}

            </Box>
          ) : count === 2 ? (
            page === "Inventory" ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : check === 0 ? "23px 15px" : "23px 15px",
                  sm : check === 0 ? "23px 15px" : "23px 15px",
                  md : check === 0 ? "30px" : "18px 40px 18px 30px",
                  lg : check === 0 ? "30px" : "18px 40px 18px 30px",
                  xl : check === 0 ? "30px" : "18px 40px 18px 30px",
                }
                  
              }}>

              <Stack
                direction="row"
                spacing={{
                  xs : 2,
                  sm : 2,
                  md : null,
                  lg : null,
                  xl : null,
                }}
                sx={{
                  justifyContent: {
                    xs : "center",
                    sm : "center",
                    md : "space-between",
                    lg : "space-between",
                    xl : "space-between",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  },
                  position: "relative",
                  alignItems: "center"
                }}>

                <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "start",
                    lg: "start",
                    xl: "start",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : "15px 0",
                    lg : null,
                    xl : null,
                  }
                }}>
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>
</Stack>
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <ButtonComp
                    buttonId="inventory"
                    variant="contained"
                    noElevate={true}
                    noRipple={true}
                    label="Add Item"
                    color="light"
                    paddings="default"
                    background="default"
                    font="default"
                    weight="default"
                    transform="default"
                    selected={true}
                    keys={false}
                    hoverTextColor="default"
                    hoverBackground="default"
                    hoverBorder="none"
                    noRead={false}
                    type="default"
                    justify="default"
                    destination="none"
                    open={true}
                    setIsModalOpen={setIsModalOpen}/>
      </Box>

                </Stack>

              </Box>
            ) : page === "Personnel Management" ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : check === 0 ? "23px 15px" : "23px 15px",
                  sm : check === 0 ? "23px 15px" : "23px 15px",
                  md : check === 0 ? "16px 40px 16px 30px" : "18px 40px 18px 30px",
                  lg : check === 0 ? "16px 40px 16px 30px" : "18px 40px 18px 30px",
                  xl : check === 0 ? "16px 40px 16px 30px" : "18px 40px 18px 30px",
                }
                  
              }}>

              <Stack
                direction="row"
                spacing={{
                  xs : 2,
                  sm : 2,
                  md : null,
                  lg : null,
                  xl : null,
                }}
                sx={{
                  justifyContent: {
                    xs : "center",
                    sm : "center",
                    md : "space-between",
                    lg : "space-between",
                    xl : "space-between",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  },
                  position: "relative",
                  alignItems: "center"
                }}>

                <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "start",
                    lg: "start",
                    xl: "start",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : "15px 0",
                    lg : null,
                    xl : null,
                  }
                }}>
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>
</Stack>
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <ButtonComp
                    buttonId="inventory"
                    variant="contained"
                    noElevate={true}
                    noRipple={true}
                    label="Add Personnel"
                    color="light"
                    paddings="default"
                    background="default"
                    font="default"
                    weight="default"
                    transform="default"
                    selected={true}
                    keys={false}
                    hoverTextColor="default"
                    hoverBackground="default"
                    hoverBorder="none"
                    noRead={false}
                    type="default"
                    justify="default"
                    destination="none"
                    open={true}
                    setIsModalOpen={setIsModalOpen}/>
                  </Box>

                </Stack>

              </Box>
            ) : page === "Services" ? (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : check === 0 ? "23px 15px" : "23px 15px",
                  sm : check === 0 ? "23px 15px" : "23px 15px",
                  md : check === 0 ? "30px" : "18px 40px 18px 30px",
                  lg : check === 0 ? "30px" : "18px 40px 18px 30px",
                  xl : check === 0 ? "30px" : "18px 40px 18px 30px",
                }
                  
              }}>

              <Stack
                direction="row"
                spacing={{
                  xs : 2,
                  sm : 2,
                  md : null,
                  lg : null,
                  xl : null,
                }}
                sx={{
                  justifyContent: {
                    xs : "center",
                    sm : "center",
                    md : "space-between",
                    lg : "space-between",
                    xl : "space-between",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  },
                  position: "relative",
                  alignItems: "center"
                }}>

                <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "start",
                    lg: "start",
                    xl: "start",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : "15px 0",
                    lg : null,
                    xl : null,
                  }
                }}>
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>
</Stack>
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <ButtonComp
                    buttonId="service"
                    variant="contained"
                    noElevate={true}
                    noRipple={true}
                    label="Add Service"
                    color="light"
                    paddings="default"
                    background="default"
                    font="default"
                    weight="default"
                    transform="default"
                    hoverTextColor="default"
                    hoverBackground="default"
                    hoverBorder="none"
                    noRead={false}
                    clickPass={onAdd}
                    type="default"
                    justify="default"
                    destination="none"
                    open={true}/>
</Box>
                </Stack>

              </Box>
            ) : (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : "23px 15px",
                  sm : "23px 15px",
                  md : check === 0 ? "30px" : "18px 40px 18px 30px",
                  lg : check === 0 ? "30px" : "18px 40px 18px 30px",
                  xl : check === 0 ? "30px" : "18px 40px 18px 30px",
                }
                  
              }}>

              <Stack
                direction="row"
                spacing={{
                  xs : 2,
                  sm : 2,
                  md : null,
                  lg : null,
                  xl : null,
                }}
                sx={{
                  justifyContent: {
                    xs : "center",
                    sm : "center",
                    md : "space-between",
                    lg : "space-between",
                    xl : "space-between",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  },
                  position: "relative",
                  alignItems: "center"
                }}>

                <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "start",
                    lg: "start",
                    xl: "start",
                  },
                  padding: {
                    xs : null,
                    sm : null,
                    md : null,
                    lg : null,
                    xl : null,
                  }
                }}>
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              sx={{
                position: "absolute",
                left: "10px",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }}
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>
                
                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text={page}
                  variant="headerh1DarkMode"/>
                </Box>

                <Box
                  display={{
                    xs: "flex",
                    sm: "flex",
                    md: "none",
                    lg: "none",
                    xl: "none",
                  }}
                  sx={{
                    position: "absolute",
                    right: "10px",
                    borderRadius: "50px"
                  }}
                >
  <div className="input-container">
    <img
      src={require("../../../../../assets/icons/search_light.png")}
      alt="icon"
      className="small"
      style={{
        position: "absolute",
        left: "8px",
        top: "32%",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        zIndex: 2,
        pointerEvents: "none",
      }}
    />

    <input
      type="text"
      name="text"
      className="input"
      placeholder="Search..."
      value={searchTerm}
      onChange={handleSearch}
    />

    {searchTerm === "asf" && (
      <button
        type="button"
        aria-label="Clear search"
        onClick={() => setSearchTerm("")}
        style={{
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          padding: 6,
          cursor: 'pointer',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icons" width="24" height="24">
          <g strokeWidth="0" id="SVGRepo_bgCarrier"></g>
          <g strokeLinejoin="round" strokeLinecap="round" id="SVGRepo_tracerCarrier"></g>
          <g id="SVGRepo_iconCarrier">
            <rect fill="white" height="24" width="24"></rect>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.9a1 1 0 0 0 1.41-1.41L13.41 12l4.9-4.89a1 1 0 0 0 0-1.4z" fillRule="evenodd" clipRule="evenodd" />
          </g>
        </svg>
      </button>
      )}
    

  </div>
                  {/* </Box> */}
                </Box>
</Stack>
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <Search
                    handleSearch={handleSearch}
                    value={searchTerm}/>
                    
</Box>
                </Stack>

              </Box>
            )
            
          ) : (
            <Box
              sx={{
                // width: "100%",
                // backgroundColor: "#000000",
                backgroundColor: {
                  xs : "#2E2D2D",
                  sm : "#2E2D2D",
                  md : "#FEFEFE",
                  lg : "#FEFEFE",
                  xl : "#FEFEFE",
                },
                borderBottom: "1px solid rgba(89, 84, 75, .2)",
                padding: {
                  xs : "10px 30px",
                  sm : "10px 30px",
                  md : "20px 30px",
                  lg : "20px 30px",
                  xl : "20px 30px",
                }
              }}>

              <Stack
                direction="row"
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center"
                }}>
                
          <Tooltip title="Menu" arrow>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              }}
              onClick={toggleDrawer(true)}
            >
              <label className="hamburger-logged-in-dark-mode">
                <input type="checkbox"/>
                <svg viewBox="0 0 32 32">
                  <path
                    className="line-logged-in-dark-mode line-top-bottom-logged-in-dark-mode"
                    d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                  ></path>
                  <path className="line-logged-in-dark-mode" d="M7 16 27 16"></path>
                </svg>
              </label>
            </Box>
          </Tooltip>
                <Drawer
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                  open={open} 
                  onClose={toggleDrawer(false)}>
                  {DrawerList}
                </Drawer>

                <Box
                  display={{
                    xs : "none",
                    sm : "none",
                    md : "flex",
                    lg : "flex",
                    xl : "flex",
                  }} 
                >
                <Text
                  text="Dashboard"
                  variant="headerh1"/>
                </Box>

                <Box
                  display={{
                    xs : "flex",
                    sm : "flex",
                    md : "none",
                    lg : "none",
                    xl : "none",
                  }} 
                >
                <Text
                  text="Dashboard"
                  variant="headerh1DarkMode"/>
                </Box>
                <Box>

                <Stack
                  direction="row"
                  spacing={3}
                  sx={{
                    alignItems: "center",
                  }}>

                  <Notification
                    setShowNotifications={setShowNotifications}
                    unreadCount={unreadCount}
                    showNotifications={showNotifications}
                    notifications={notifications}
                    setNotifications={setNotifications}
                    setShowNotificationsModal={setShowNotificationsModal}
                    userDetails={userDetails}/>

                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "block",
                        lg: "block",
                        xl: "block",
                      }
                    }}
                  >
                  <Button
                    variant="contained"
                    onClick={handleManageAppointmentClick}
                    disabled={isManageAppointmentLoading}
                    sx={{
                      backgroundColor: "#C5A572",
                      color: "#FDF9F3",
                      border: "1px solid #C5A572",
                      padding: "10px 20px",
                      borderRadius: "25px",
                      cursor: isManageAppointmentLoading ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      textTransform: "none",
                      fontWeight: "bold",
                      fontSize: "14px",
                      "&:hover": {
                        backgroundColor: "#B8955A",
                        borderColor: "#B8955A",
                      },
                      "&:disabled": {
                        backgroundColor: "#E0D6C3",
                        borderColor: "#E0D6C3",
                        color: "#999",
                      },
                    }}
                  >
                    {isManageAppointmentLoading ? (
                      <>
                        <CircularProgress size={16} sx={{ color: "#FDF9F3" }} />
                        <span>Manage Appointment...</span>
                      </>
                    ) : (
                      "Manage Appointment"
                    )}
                  </Button>
                  </Box>

                </Stack>
                </Box>

              </Stack>

            </Box>
          )}
        
        </>
      )}

    </div>
  );
};

export default HeaderLoggedIn;